import { Box, Text } from '@chakra-ui/react';
import { IProduct } from '../../interfaces';
import Colors from '../../config/colors';
import truncate from '../../utils/truncate';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getFormatedPrice } from '../../utils/price';
import PlatformList from '../platformList/PlatformList';
import { getFilteringPlatforms } from '../../utils/platform';

interface Props {
    product: IProduct;
}

export default function ProductCard({ product }: Props) {
    const firstImageURL = product.mainImage;

    const platforms: any = getFilteringPlatforms(product.platforms);
    const genres = product?.genres?.slice(0, 4).join(', ');

    return (
        <Box borderRadius="0px" background={Colors.darkBlue2} padding="10px 10px 10px 0px">
            <Box display="flex" alignItems="center" justifyContent="space-between" gap="10px">
                <Box display="flex" alignItems="center" gap="10px">
                    <LazyLoadImage
                        src={firstImageURL ?? ''}
                        effect="blur"
                        style={{
                            display: 'block',
                            maxWidth: '130px',
                        }}
                    />
                    <Box display="flex" flexDirection="column" justifyContent="center">
                        <Text fontSize="15px" fontWeight="300" color="#fff">
                            {truncate(product.name, 20)}
                        </Text>
                        <PlatformList platforms={platforms} />
                        <Text
                            fontSize="14px"
                            color={Colors.darkGrey}
                            wordBreak="break-all"
                            overflowY="hidden"
                            height="20px">
                            {genres}
                        </Text>
                    </Box>
                </Box>
                <Box>
                    <Text color="#fff" fontWeight="300">
                        {getFormatedPrice(
                            product.price,
                            product.localeType.currency,
                            product.localeType.name,
                        )}
                    </Text>
                </Box>
            </Box>
        </Box>
    );
}
